// Donation configuration.
// HelloAsso "Faire un don" form for the association.
export const HELLOASSO_URL = "https://www.helloasso.com/associations/petitspas/formulaires/1";
// Embeddable widget version of the form (shown inside the site on the /don page).
export const HELLOASSO_WIDGET_URL =
  "https://www.helloasso.com/associations/petitspas/formulaires/1/widget";
